import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import styled from 'styled-components';

export const DownArrow = styled(ArrowDownwardIcon)`
  position: absolute;
  bottom: -12px;
  left: -5px;
  width: 11px !important;
  path {
    fill: #96979b;
  }
`;

export const NotesSidebar = styled.aside`
  max-width: 270px;
  width: 100%;
  height: fit-content;
  position: sticky;
  top: 67px;
`;

export const SidebarTopics = styled.div`
  &:before {
    content: '';
    height: 100%;
    background: #96979b;
    width: 1px;
    position: absolute;
    left: 0px;
  }
  padding-left: 21px;
  position: relative;
`;

export const SidebarSubtitle = styled.p`
  margin-bottom: 16px;
  color: ${(props) => props.theme.colors['neutral-100']};
  font-size: 16px;
  line-height: 18px;
  font-weight: 600;
`;

export const Stage = styled.p`
  margin-bottom: 16px;
  text-transform: uppercase;
  color: ${(props) => props.theme.colors['neutral-80']};
  font-size: 9px;
  font-weight: 700;
  line-height: 10px;
  position: relative;
  &:before {
    content: '';
    width: 5px;
    height: 5px;
    background: #96979b;
    position: absolute;
    top: 0;
    left: -23px;
    border-radius: 50px;
  }
`;

export const Topic = styled.button`
  margin-bottom: 16px;
  color: ${(props) => props.theme.colors['neutral-100']};
  font-size: 14px;
  line-height: 21px;
  display: block;
  text-align: left;
`;

export const NewTopicButton = styled.button`
  margin-bottom: 32px;
  font-size: 14px;
  line-height: 21px;
  display: block;
  color: ${(props) => props.theme.colors['primary-60']};
`;
